"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrdersStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useOrdersStore = (0, pinia_1.defineStore)("ordersStore", {
    state: () => ({
        orders: [],
        orderItems: null,
        orderDeliveryInfos: [],
    }),
    getters: {
        order: (state) => state.orders[0] // returns the first element if available
    },
    actions: {
        async getOrder(router, id) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({
                    name: "api_order",
                    params: { id }
                }).href);
                this.orders = [response];
                return response;
            }
            catch (error) {
                console.error("Order fetch failed:", error);
                throw error;
            }
        },
        async getOrders(router, query, customerId) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({
                    name: "axapta_orders_api",
                    query: {
                        customerId: customerId,
                        startDate: query.startDate,
                        endDate: query.endDate,
                        orderIdPartial: query.orderIdPartial,
                        containOnlyTransferred: query.containOnlyTransferred ? "true" : "false"
                    }
                }).href);
                this.orders = response;
                return response;
            }
            catch (error) {
                console.error("Orders fetch failed:", error);
                throw error;
            }
        },
        async getOrderItems(router, params = {}) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_order_items_api", query: params }).href);
                this.orderItems = response;
                return response;
            }
            catch (error) {
                console.error("Order items fetch failed:", error);
                throw error;
            }
        },
        async getOrderDeliveryInfos(router, params = {}) {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_order_delivery_infos_api", query: params }).href);
                this.orderDeliveryInfos = response;
                return response;
            }
            catch (error) {
                console.error("Order delivery infos fetch failed:", error);
                throw error;
            }
        },
        async sendTransferredOrdersReportInEmail(router, payload) {
            try {
                const options = { body: JSON.stringify(payload), method: "POST" };
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_send_transferred_orders_report_in_email_api" }).href, options);
                if (response.status !== "success") {
                    throw Error(response.error);
                }
                return response;
            }
            catch (error) {
                console.error("Send orders report failed:", error);
                throw error;
            }
        },
        reset() {
            this.orders = [];
        },
        resetOrderItems() {
            this.orderItems = null;
        },
        resetOrderDeliveryInfos() {
            this.orderDeliveryInfos = [];
        },
    }
});
